interface JPBEventPayload {
  module: 'JPB'
  event: 'GO_HOME'
  data: Record<string, unknown>
}

interface CustomWindow extends Window {
  ReactNativeWebView?: {
    postMessage: (message: string) => void
  }
  android?: {
    __externalCall: (message: string) => void
  }
  __externalCall?: (message: string) => void
  webkit?: {
    messageHandlers?: {
      callback?: {
        postMessage: (message: string) => void
      }
    }
  }
}

declare const window: CustomWindow

const useJPBBridge = () => {
  const isIOS = (): boolean =>
    /iPad|iPhone|iPod/.test(window.navigator.userAgent)

  const sendJPBEvent = (payload: JPBEventPayload): void => {
    if (window) {
      const encodedData = window?.btoa?.(JSON.stringify(payload))

      if (window?.ReactNativeWebView) {
        window?.ReactNativeWebView?.postMessage(encodedData)
      } else if (window?.android?.__externalCall) {
        window?.android?.__externalCall(encodedData)
      } else if (window?.__externalCall) {
        window?.__externalCall(encodedData)
      } else if (isIOS() && window?.webkit?.messageHandlers?.callback) {
        window?.webkit?.messageHandlers?.callback?.postMessage(encodedData)
      }
    }
  }

  const goBack = (): void => {
    sendJPBEvent({
      module: 'JPB',
      event: 'GO_HOME',
      data: {},
    })
  }

  return { goBack, isIOS }
}

export default useJPBBridge
